import React from 'react';
import isFunction from 'lodash/isFunction';
import useFormGroup from '../hooks/useFormGroup';
import Adapter from './Adapter';
import useAdapter from '../hooks/useAdapter';
// eslint-disable-next-line import/no-cycle
import getFieldComponent from '../utils/getFieldComponent';

export default function FormGroup({ children, ...userProps }) {
  const adapter = useAdapter();
  const { fields, formGroupContext, formGroupProps, render } = useFormGroup(userProps);

  if (isFunction(children)) {
    return children(formGroupContext);
  }

  return render(
    <Adapter component="FormGroup" {...formGroupProps} context={formGroupContext}>
      {children ||
        Object.entries(fields).map(([$ref, field]) => {
          const FieldComponent = getFieldComponent(adapter, field);

          return <FieldComponent key={$ref} $ref={$ref} />;
        })}
    </Adapter>
  );
}
